import { render, staticRenderFns } from "./ModalWindow.vue?vue&type=template&id=83d6f098&"
var script = {}
import style0 from "./ModalWindow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports